import React from "react";
import PropTypes from "prop-types";

export default class Options extends React.PureComponent{

    static propTypes = {
        options: PropTypes.array,
        name: PropTypes.string,
        language: PropTypes.string,
        blankOption: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
		const { options, name, blankOption, language } = this.props;
		options.sort((item1,item2) => item1.name.localeCompare(item2.name));
        return (
            <>
                {name && (<option value={''} selected={true} disabled>{window.Translator.getSlug(name, language)}</option>)}
                {blankOption && (<option value={''} />)}
                {options.map(function (item, id) {
                    return (<option value = {item.id}>{item.name}</option>)
                })}
            </>
        );
    }
}
